
export default function BenefitsBar() {
  const benefits = [
    {
      icon: 'ri-truck-line',
      title: 'Envíos a todo el país',
      description: 'Gratis en compras superiores a USD 300'
    }
  ];

  return (
    <section className="py-12 bg-gray-900 border-y border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="flex items-center space-x-4 p-4 group hover:bg-black/50 transition-all duration-300 rounded-lg"
            >
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#C6A45C] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className={`${benefit.icon} text-black text-xl`}></i>
                </div>
              </div>
              <div>
                <h3 className="text-white font-thin text-sm uppercase tracking-wider mb-1" style={{ fontFamily: '"Lato", sans-serif' }}>
                  {benefit.title}
                </h3>
                <p className="text-gray-400 text-sm font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
